<template>
  <div class="admin-payment-qr">
    <QrPaymentAlert :failure="qrFailure" @close="qrFailure = null" />
    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus" class="mr-1" @click="onPressedActiveAddQrPayment()">สร้าง QR CODE</vs-button>
    <vs-popup
      :active.sync="qrPaymentModal.active"
      :title="expenseOnly ? 'สร้าง QR CODE (Admin) — ค่าใช้จ่าย' : 'สร้าง QR CODE (Admin)'"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form2">
          <form @submit.prevent="handleSubmit">
            <p v-if="!expenseOnly" class="mb-3">เลือกยอดชำระ ระบบจะตรวจสอบยอดล่าสุดอีกครั้งก่อนออก QR Code</p>
            <p v-if="expenseOnly && qrPaymentModal.loading">กำลังโหลดยอด…</p>
            <p v-else-if="expenseOnly && !qrPaymentModal.details.allExpenses">ไม่สามารถโหลดยอดค่าใช้จ่ายได้ กรุณาลองอีกครั้ง</p>
            <p v-else-if="expenseOnly && !visibleQrAmountOptions.length">ไม่มีค่าใช้จ่ายค้างชำระ</p>
            <div class="payment-amount-options" :class="{ 'expense-options': expenseOnly }">
              <button v-for="option in visibleQrAmountOptions" :key="option.type" type="button"
                      :class="{ selected: qrPaymentModal.type === option.type }"
                      :disabled="qrPaymentModal.loading || qrPaymentModal.submitting || !(qrPaymentModal.details[option.type] && qrPaymentModal.details[option.type].amount > 0)"
                      @click="selectQrAmount(option.type)">
                <span>{{ option.label }}</span><br>
                <strong v-if="qrPaymentModal.details[option.type]">{{ qrPaymentModal.details[option.type].amount | numberFormat }} บาท</strong>
                <span v-else>{{ qrPaymentModal.loading ? 'กำลังโหลดยอด…' : 'ไม่สามารถแสดงยอดได้' }}</span>
              </button>
              <button v-if="!expenseOnly" class="custom-amount-option" type="button" :class="{ selected: qrPaymentModal.type === 'custom' }"
                      :disabled="qrPaymentModal.submitting" @click="selectQrAmount('custom')">กำหนดยอดเอง</button>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }" >
                  <label class="text-sm">จำนวน*</label>
                  <vs-input type="number" class="w-full" v-model="qrPaymentModal.amount" :disabled="qrPaymentModal.type !== 'custom' || qrPaymentModal.submitting"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2" v-if="qrPaymentModal.type === 'custom'">
                <ValidationProvider name="ไม่กำหนดยอดชำระขั้นต่ำ" rules="" v-slot="{ errors }" >
                  <label class="text-sm">ไม่กำหนดยอดชำระขั้นต่ำ</label>
                  <vs-checkbox v-model="qrPaymentModal.skipLimit"></vs-checkbox>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" :disabled="qrPaymentModal.loading || qrPaymentModal.submitting || !(qrPaymentModal.amount > 0)" @click="onPressedAcceptAddQrPayment">สร้าง QR Code</vs-button>
        <vs-button color="danger" @click="qrPaymentModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

    <QrPaymentModal :active.sync="paymentPopup" :qr="qrSnapshot" />
  </div>
</template>
<script>
import QrPaymentModal from "@/components/QrPaymentModal.vue";
import QrPaymentAlert from "@/components/QrPaymentAlert.vue";
import { createNamespacedHelpers } from "vuex";
import { IQrPaymentType } from "@/constants/interface";
import { apolloClient } from "@/setup/apollo-setup";
import gql from "graphql-tag";
const paymentAmountQuery = gql`
  query AdminPaymentAmount($contractId: ID!, $type: String!, $amount: Float) {
    getPaymentAmountDetailByContractId(contractId: $contractId, type: $type, amount: $amount) {
      amount paidContractFee paidTaxAmount paidProcessingFee paidCourtOrderExpense
    }
  }
`;
const { mapActions, mapState } = createNamespacedHelpers("Accounting");
export default {
  name: "AdminPaymentQr",
  components: { QrPaymentAlert, QrPaymentModal },
  props: { expenseOnly: { type: Boolean, default: false } },
  data() { return { qrSnapshot: null, qrFailure: null,
      paymentPopup: false,
      qrPaymentModal: {
        active: false,
        amount: 0,
        skipLimit: false,
        type: 'custom',
        details: {},
        loading: false,
        submitting: false,
        requestId: 0,
      },
      qrAmountOptions: [
        { type: 'outstanding', label: 'ยอดค้างชำระ' },
        { type: 'normal', label: 'ยอดปัจจุบัน' },
        { type: 'close', label: 'ยอดปิดบัญชี' },
        { type: 'allExpenses', label: 'ยอดรวม' },
      ],
      qrExpenseFields: [
        { key: 'paidContractFee', type: 'contractFee', label: 'ค่าธรรมเนียมการทำสัญญา' },
        { key: 'paidTaxAmount', type: 'taxAmount', label: 'ค่าอากรแสตมป์' },
        { key: 'paidProcessingFee', type: 'processingFee', label: 'ค่าดำเนินการ' },
        { key: 'paidCourtOrderExpense', type: 'courtOrderExpense', label: 'ค่าใช้จ่ายอื่นตามคำสั่งศาล' },
      ],
  }; },
  computed: {
    ...mapState(["qrPayment"]),
    IQrPaymentType() { return IQrPaymentType; },
    visibleQrAmountOptions() {
      if (!this.expenseOnly) return this.qrAmountOptions.filter(option => option.type !== 'allExpenses')
      return [...this.qrExpenseFields, { type: 'allExpenses', label: 'ยอดรวม' }]
        .filter(option => this.qrPaymentModal.details[option.type] && this.qrPaymentModal.details[option.type].amount > 0)
    },
  },
  methods: {
    ...mapActions(["createQrPayment"]),
    async onPressedActiveAddQrPayment() {
      const vm = this
      if (vm.qrPaymentModal.submitting) return
      vm.qrPaymentModal.active = true
      vm.qrPaymentModal.amount = 0
      vm.qrPaymentModal.skipLimit = false
      vm.qrPaymentModal.type = vm.expenseOnly ? 'allExpenses' : 'custom'
      vm.qrPaymentModal.details = {}
      vm.qrPaymentModal.loading = true
      const requestId = ++vm.qrPaymentModal.requestId
      const contractId = vm.$route.params.id
      const details = {}
      const queryOptions = vm.expenseOnly ? [{ type: 'allExpenses' }] : vm.visibleQrAmountOptions
      await Promise.all(queryOptions.map(async option => {
        try {
          const response = await apolloClient.query({
            query: paymentAmountQuery,
            variables: { contractId, type: option.type, amount: 0 },
            fetchPolicy: 'no-cache',
          })
          details[option.type] = response.data.getPaymentAmountDetailByContractId
        } catch (_) {
          details[option.type] = null
        }
      }))
      if (requestId !== vm.qrPaymentModal.requestId || contractId !== vm.$route.params.id) return
      if (vm.expenseOnly && details.allExpenses) {
        vm.qrExpenseFields.forEach(item => {
          details[item.type] = { amount: Number(details.allExpenses[item.key]) || 0 }
        })
      }
      vm.qrPaymentModal.details = details
      vm.qrPaymentModal.loading = false
      if (vm.expenseOnly && details.allExpenses) vm.selectQrAmount('allExpenses')
    },
    selectQrAmount(type) {
      if (this.qrPaymentModal.submitting || this.qrPaymentModal.loading) return
      if (!this.visibleQrAmountOptions.some(option => option.type === type) && !(type === 'custom' && !this.expenseOnly)) return
      this.qrPaymentModal.type = type
      this.qrPaymentModal.skipLimit = false
      this.qrPaymentModal.amount = type === 'custom' ? 0 : this.qrPaymentModal.details[type].amount
    },
    async onPressedAcceptAddQrPayment () {
      // chang from  btnQrPayment to onPressedAcceptAddQrPayment
      const vm = this
      if (vm.qrPaymentModal.loading || vm.qrPaymentModal.submitting) return
      vm.qrPaymentModal.submitting = true
      const contractId  = this.$route.params.id;
      return vm.$refs['form2'].validate().then(async success => {
        if (!success) {
          vm.qrPaymentModal.submitting = false
          return
        }
        const { createQrPayment } = vm
        const result = await createQrPayment({
          silent: true,
          contractId: contractId,
          form: { type: vm.qrPaymentModal.type, amount: parseFloat(vm.qrPaymentModal.amount), skipLimit: vm.qrPaymentModal.type === 'custom' && vm.qrPaymentModal.skipLimit }
        })
        if(result !== true) {
          vm.qrFailure = result || new Error('QR creation failed')
          return
        }
        if(result === true && contractId === vm.$route.params.id){
          vm.qrPaymentModal.active = false;
          const { qrPayment } = vm
          vm.qrSnapshot = { ...qrPayment }
          vm.paymentPopup = true
        }
      }).catch(error => {
        vm.qrFailure = error
      }).finally(() => {
        vm.qrPaymentModal.submitting = false
      });
    },
  },
};
</script>
<style scoped>

.vx-row {
  margin-bottom: 15px;
}

.custom-popup >>> .vs-popup {
  width: 600px;
  max-width: calc(100vw - 32px);
}
.popup-content {
  padding: 10px;
}
.payment-amount-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}
.custom-amount-option { grid-column: 1 / -1; }
.payment-amount-options button {
  padding: 12px;
  border: 1px solid #d5dce3;
  border-radius: 6px;
  background: white;
  color: #174e78;
  cursor: pointer;
}
.payment-amount-options button.selected { background: #eaf3fa; border-color: #174e78; }
.payment-amount-options button:disabled { opacity: .5; cursor: default; }
@media (max-width: 480px) {
  .payment-amount-options { grid-template-columns: 1fr; }
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}






</style>
